import { getLeadingCommentRanges } from "typescript"

export function getLang(): "ja" | "en" {
  if (typeof window === "undefined") {
    return "ja"
  }
  return /^\/en/.test(window.location.pathname) ? "en" : "ja"
}
